"use strict";
import { BorderedAlertTriangle } from "components/Icons/BorderedAlertTriangle";
import { Flex, Image } from "ui/src";
import { WalletAlert } from "ui/src/components/icons/WalletAlert";
import { normalizeBase64Image } from "utils/images";
export function WalletAlertBadge({
  iconSize = "$spacing48",
  walletIconSize = 30,
  badgeSize = 24,
  walletIcon,
  walletColor = "$neutral2",
  badgeColor = "$statusWarning"
}) {
  const cleanImageSrc = walletIcon ? normalizeBase64Image(walletIcon) : void 0;
  return <Flex position="relative" height={iconSize} width={iconSize} justifyContent="center" alignItems="center">
      {cleanImageSrc ? <Image src={cleanImageSrc} width={iconSize} height={iconSize} borderRadius="$rounded8" /> : <Flex
    backgroundColor="$surface3"
    height={iconSize}
    width={iconSize}
    alignItems="center"
    justifyContent="center"
    mb="$spacing4"
  >
          <WalletAlert color={walletColor} size={walletIconSize} />
        </Flex>}
      <Flex position="absolute" bottom={0} right={-10}>
        <BorderedAlertTriangle height={badgeSize} width={badgeSize} color={badgeColor} />
      </Flex>
    </Flex>;
}
